import React, { useMemo, useState } from "react"
import { CardBody, Card } from "reactstrap"
import moment from "moment"
import CommonTable from "components/Common/CommonTable"

const PriorityTasks = ({ heading, tasks_data }) => {
  const [selectedDate, setSelectedDate] = useState("")

  const filteredData = useMemo(() => {
    if (!selectedDate) return tasks_data

    return tasks_data.filter(task => {
      return (
        moment(task.createdAt).format("YYYY-MM-DD") ===
        moment(selectedDate).format("YYYY-MM-DD")
      )
    })
  }, [selectedDate, tasks_data])

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        className: "text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Task",
        accessor: "title",
      },
      {
        Header: "Client Name",
        accessor: "clientName",
      },
      {
        Header: "Client Code",
        accessor: "clientCode",
      },
      {
        Header: "Priority",
        accessor: "taskPriorityStatus",
        Cell: cellProps => (
          <span className="text-danger fw-bold">
            {cellProps.row.original.taskPriorityStatus}
          </span>
        ),
        className: "text-center",
      },
      {
        Header: "Period End",
        accessor: "startDate",
        Cell: cellProps => (
          <span>
            {moment(cellProps.row.original.startDate).format("DD MMM YYYY")}
          </span>
        ),
      },
      {
        Header: "Due Date",
        accessor: "dueDate",
        Cell: cellProps => (
          <span>
            {moment(cellProps.row.original.dueDate).format("DD MMM YYYY")}
          </span>
        ),
      },
      {
        Header: "Status",
        accessor: "statusName",
        className: "text-center",
        Cell: cellProps => {
          const { colorCode, statusName } = cellProps.row.original.status
          return (
            <span
              className="badge"
              style={{
                color: colorCode,
                border: `1px solid ${colorCode}`,
                fontSize: "11px",
              }}
            >
              {statusName}
            </span>
          )
        },
      },
    ],
    []
  )

  return (
    <div>
      <Card className="px-0 mx-0">
        <CardBody>
          <CommonTable columns={columns} data={filteredData} heading={heading}>
            <div
              className="d-flex align-items-center gap-2 mb-3"
              title="Filter by Task Creation Date"
            >
              <input
                type="date"
                value={selectedDate}
                onChange={e => setSelectedDate(e.target.value)}
                className="form-control ms-2"
              />
            </div>
          </CommonTable>
        </CardBody>
      </Card>
    </div>
  )
}

export default PriorityTasks
